<template>
  <transition name="fade">
    <div>
      <b-modal
        :id="modalId"
        ref="myModalRef"
        :hide-header="true"
        :hide-footer="true"
        @hidden="resetForm"
      >
        <button
          type="button"
          class="close"
          aria-label="Close"
          @click="closeModal"
        >
          <span aria-hidden="true">
            <img src="../assets/icons/close.svg" alt="Avbryt endre varsel" />
          </span>
        </button>
        <div v-show="!showLevelSelector" class="mx-md-2 my-md-3">
          <h1>{{ title }}</h1>

          <p>
            Du blir varslet om {{ displayName }} for de nivåene og områdene du
            velger. Du kan legge til flere forskjellige varslingsområder.
          </p>

          <h5>Nivå som varsles</h5>
          <div class="card" :class="levelClass" @click="changeLevel">
            <div class="card-body">
              <span class="card-text card-level-text">{{
                selectedLevelText
              }}</span>
              <div class="float-right">
                <a href="#" @click.prevent="changeLevel">
                  <small>Endre</small>
                </a>
              </div>
            </div>
          </div>

          <h5>Varslingsområde</h5>
          <div v-show="showError" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>

          <CountySelector
            :existingSubscription="existingSubscription"
            :subscriptionType="subscriptionType"
            ref="countySelector"
            v-if="subscriptionType.regionType == 1"
            @regionAdded="
              (municipalities) => {
                municipalitiesChanged(municipalities);
              }
            "
            @norwaySelected="
              (norwaySelected) => {
                this.norwaySelected = norwaySelected;
              }
            "
          />

          <AvalancheRegionSelector
            :existingSubscription="existingSubscription"
            :subscriptionType="subscriptionType"
            ref="avalancheRegionSelector"
            v-if="subscriptionType.regionType == 2"
            @regionAdded="
              (regions) => {
                avalancheRegionsChanged(regions);
              }
            "
            @norwaySelected="
              (norwaySelected) => {
                this.norwaySelected = norwaySelected;
              }
            "
          />

          <RockslideObjectSelector
            :existingSubscription="existingSubscription"
            :subscriptionType="subscriptionType"
            ref="rockslideObjectSelector"
            v-if="subscriptionType.regionType == 3"
            @regionAdded="
              (rockslideObjects) => {
                rockslideObjectsChanged(rockslideObjects);
              }
            "
            @norwaySelected="
              (norwaySelected) => {
                this.norwaySelected = norwaySelected;
              }
            "
          />

          <h5 class>Varslingsmetode</h5>
          <fieldset id="varslingsmetode" v-if="!disableSMS">
            <label class="input-label">
              <input
                type="radio"
                v-model="alertMethod"
                value="1"
                name="vm-group"
                checked
              />E-post
            </label>
            <label class="input-label">
              <input
                type="radio"
                v-model="alertMethod"
                value="2"
                name="vm-group"
              />SMS
            </label>
            <label class="input-label">
              <input
                type="radio"
                v-model="alertMethod"
                value="3"
                name="vm-group"
              />E-post og SMS
            </label>
          </fieldset>
          <p class="info-text">
            <span v-if="disableSMS"
              >Varsles på e-post. Legg til mobilnummer i
              NVE konto for å kunne motta varsler på SMS.</span
            >
          </p>

          <div class="boxes" v-if="showRelatedAlerts">
            <h5 class>Anbefalte tilleggsvarsler</h5>
            <div v-if="subscriptionType.hazardTypeId != TypeService.Flood">
              <label :for="relatedFlood">
                <input
                  type="checkbox"
                  v-model="relatedFlood"
                  :id="relatedFlood"
                />
                Flom
              </label>
              <InfoPopup
                class
                :popid="getPopId(TypeService.Flood)"
                :text="getInfoText(TypeService.Flood)"
              />
            </div>
            <div v-if="subscriptionType.hazardTypeId != TypeService.Landslide">
              <label :for="relatedLandslide">
                <input
                  :id="relatedLandslide"
                  v-model="relatedLandslide"
                  type="checkbox"
                />
                Jordskred
              </label>
              <InfoPopup
                class
                :popid="getPopId(TypeService.Landslide)"
                :text="getInfoText(TypeService.Landslide)"
              />
            </div>
            <div v-if="subscriptionType.hazardTypeId != TypeService.RainFlood">
              <label :for="relatedRainFlood">
                <input
                  type="checkbox"
                  v-model="relatedRainFlood"
                  :id="relatedRainFlood"
                />
                Styrtregn
              </label>
              <InfoPopup
                class
                :popid="getPopId(TypeService.RainFlood) + '-2'"
                :text="getInfoText(TypeService.RainFlood)"
              />
            </div>
          </div>
          <br />

          <div class>
            <button
              type="button"
              class="btn btn-nve btn-primary"
              @click="completeModal"
            >
              Fullfør varsel
            </button>
            <a href="#" class="cancel" @click="closeModal">Avbryt</a>
          </div>
        </div>

        <LevelSelector
          :subscriptionType="subscriptionType"
          :selectedLevel="selectedLevel"
          v-show="showLevelSelector"
          v-if="subscriptionType.regionType == 1 || subscriptionType.regionType == 3"
          @levelSelected="checkSelectedLevel"
        />

        <AvalancheLevelSelector
          :subscriptionType="subscriptionType"
          :selectedLevel="selectedLevel"
          v-show="showLevelSelector"
          v-if="subscriptionType.regionType == 2"
          @levelSelected="checkSelectedLevel"
        />

      </b-modal>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import RockslideObjectSelector from "./RockslideObjectSelector.vue";
import LevelSelector from "./LevelSelector.vue";
import CountySelector from "./CountySelector.vue";
import AvalancheLevelSelector from "./AvalancheLevelSelector.vue";
import AvalancheRegionSelector from "./AvalancheRegionSelector.vue";
import InfoPopup from "@/components/InfoPopup.vue";
import TypeService from "../store/TypeService.js";

export default {
  name: "NewOrEditSubscription",
  components: {
    LevelSelector,
    CountySelector,
    AvalancheRegionSelector,
    AvalancheLevelSelector,
    RockslideObjectSelector,
    InfoPopup,
  },
  props: {
    subscriptionType: {},
    existingSubscription: {},
  },
  data() {
    return {
      TypeService: TypeService,
      selectedMunicipalities: [],
      selectedAvalancheRegions: [],
      selectedRockslideObjects: [],
      selectedLevel: 2,
      showLevelSelector: false,
      norwaySelected: false,
      showError: false,
      relatedFlood: false,
      relatedLandslide: false,
      relatedRainFlood: false,
      errorMessage: "Det har oppstått en feil",
      alertMethod: "1",
    };
  },
  created() {
    this.resetForm();
  },
  methods: {
    resetForm() {
      // defaults
      this.showLevelSelector = false;
      this.selectedMunicipalities = [];
      this.selectedRockslideObjects = [];
      this.selectedLevel = 2;
      this.alertMethod = "1";

      // clean children
      if (this.subscriptionType.regionType === 1) {
        if (this.$refs.countySelector)
          this.$refs.countySelector.clearAddedMunicipalities();
      } else if (this.subscriptionType.regionType === 2) {
        if (this.$refs.avalancheRegionSelector)
          this.$refs.avalancheRegionSelector.clearAddedRegions();
      } else if (this.subscriptionType.regionType === 3) {
        if (this.$refs.rockslideObjectSelector)
          this.$refs.rockslideObjectSelector.clearRockslideObjects();
      }

      // update from exisitng sub
      if (this.existingSubscription) {
        this.selectedMunicipalities = this.existingSubscription.municipalities;
        this.selectedAvalancheRegions = this.existingSubscription.avalancheRegions;
        this.selectedLevel = this.existingSubscription.level;
        this.norwaySelected = this.existingSubscription.isRegionNorway;
        if (
          this.existingSubscription.sendEmail &&
          this.existingSubscription.sendSMS
        )
          this.alertMethod = "3";
        else if (this.existingSubscription.sendSMS) this.alertMethod = "2";
      }
    },
    closeModal() {
      this.$refs.myModalRef.hide();
    },
    checkSelectedLevel(level) {
      if (level > 0) {
        this.selectedLevel = level;
      }
      this.showLevelSelector = false;
    },
    completeModal() {
      this.loadingData = true;

      if (
        this.selectedMunicipalities.length < 1 &&
        this.selectedAvalancheRegions < 1 &&
        this.selectedRockslideObjects < 1 &&
        !this.norwaySelected
      ) {
        this.showError = true;
        this.errorMessage =
          "Du må legge til minst et varslingsområde for å fullføre varselet";
        return;
      }

      this.showError = false;
      let hazardType = this.subscriptionType.hazardTypeId;
      if (this.relatedFlood) {
        hazardType += ";" + TypeService.Flood;
      }
      if (this.relatedLandslide) {
        hazardType += ";" + TypeService.Landslide;
      }
      if (this.relatedRainFlood) {
        hazardType += ";" + TypeService.RainFlood;
      }

      const newSubscription = {
        HazardType: hazardType,
        IsRegionNorway: this.norwaySelected,
        Level: this.selectedLevel,
        SendSMS: this.alertMethod === "2" || this.alertMethod === "3",
        SendEmail: this.alertMethod === "1" || this.alertMethod === "3",
      };

      if (this.subscriptionType.regionType === 1) {
        newSubscription.Regions = this.selectedMunicipalities;
      } else if (this.subscriptionType.regionType === 2) {
        newSubscription.Regions = this.selectedAvalancheRegions;
      } else if (this.subscriptionType.regionType === 3) {
        newSubscription.Regions = this.selectedRockslideObjects;
      }

      if (
        this.existingSubscription &&
        this.existingSubscription.id.length > 0
      ) {
        // endre eksisterende abonnement
        axios
          .put(
            `/api/api/Subscription/Modify/${this.existingSubscription.id}`,
            newSubscription
          )
          .then(
            () => {
              this.$refs.myModalRef.hide();
              this.$emit("subscriptionSaved");
            },
            (e) => {
              if (e.response.status === 304) {
                this.$refs.myModalRef.hide();
                this.$emit("subscriptionSaved");
              } else {
                this.errorMessage = "Klarte ikke å endre varslet";
                this.showError = true;
              }
            }
          );
      } else {
        // nytt abonnement
        axios.post("/api/api/Subscription/New", newSubscription).then(
          () => {
            this.$refs.myModalRef.hide();
            this.resetForm();
            this.$emit("subscriptionSaved");
          },
          () => {
            this.errorMessage = "Klarte ikke å legge til varslet";
            this.showError = true;
          }
        );
      }
    },
    changeLevel() {
      this.showLevelSelector = true;
    },

    rockslideObjectsChanged(rockslideObjects){
      if(rockslideObjects.length > 0) {
        this.selectedRockslideObjects = rockslideObjects.map((r) => r.name);        
      } else{
        this.selectedRockslideObjects = [];
      }
      this.showError = false;
    },

    municipalitiesChanged(municipalities) {
      if (municipalities.length > 0) {
        this.selectedMunicipalities = municipalities.map((m) => m.councilId);
      } else {
        this.selectedMunicipalities = [];
      }
      this.showError = false;
    },

    avalancheRegionsChanged(regions) {
      if (regions.length > 0) {
        this.selectedAvalancheRegions = regions.map((r) => r.regionId);
      } else {
        this.selectedAvalancheRegions = [];
      }
      this.showError = false;
    },
    getPopId(hazardTypeId) {
      return "popover-id-rel-new-" + hazardTypeId;
    },
    getInfoText(hazardTypeId) {
      return TypeService.getInfoText(hazardTypeId);
    },
  },
  computed: {
    modalId() {
      if (!this.existingSubscription) {
        return `modal-${this.subscriptionType.hazardTypeId}`;
      }
      return `modal-${this.existingSubscription.id}`;
    },
    displayName() {
      return this.subscriptionType.displayName.toLowerCase();
    },
    disableSMS() {
      if (this.$store.getters.disableSMS) {
        return true;
      }
      return false;
    },
    title() {
      if (!this.existingSubscription) {
        return `Varsel om ${this.subscriptionType.displayName.toLowerCase()}`;
      }

      return `Varsel om ${this.subscriptionType.displayName}`;
    },
    levelClass() {
      return `level-${this.selectedLevel}`;
    },
    selectedLevelText() {
      let returnValue = "";
      if (this.subscriptionType.regionType !== 2) {
        switch (this.selectedLevel) {
          case 2:
            returnValue = "GULT, ORANSJE, RØDT";
            break;
          case 3:
            returnValue = "ORANSJE, RØDT";
            break;
          case 4:
            returnValue = "RØDT";
            break;
          default:
            returnValue = "(ingen valgt)";
            break;
        }
      } else if (this.subscriptionType.regionType === 2) {
        switch (this.selectedLevel) {
          case 2:
            returnValue = "GULT, ORANSJE, RØDT, SVART";
            break;
          case 3:
            returnValue = "ORANSJE, RØDT, SVART";
            break;
          case 4:
            returnValue = "RØDT, SVART";
            break;
          case 5:
            returnValue = "SVART";
            break;
          default:
            returnValue = "(ingen valgt)";
        }
      }

      // crazyfix fordi det SELVFØLGELIG IKKE KAN VARSLES LIKT FOR ALLE TYPER!!!!! forvent mere if'er og drit inn her
      if (
        this.subscriptionType.hazardTypeId === TypeService.BlowingSnow ||
        this.subscriptionType.hazardTypeId === TypeService.Lightning ||
        this.subscriptionType.hazardTypeId === TypeService.PolarLow ||
        this.subscriptionType.hazardTypeId === TypeService.ForestFire ||
        this.subscriptionType.hazardTypeId === TypeService.RainFlood ||
        this.subscriptionType.hazardTypeId === TypeService.Ice
      ) {
        returnValue = returnValue.replace(", RØDT", "");
      }
      if (this.subscriptionType.hazardTypeId === TypeService.BlowingSnow || this.subscriptionType.hazardTypeId === TypeService.Lightning) {
        returnValue = returnValue.replace(", ORANSJE", "");
      }
      return returnValue;
    },

    showRelatedAlerts() {
      if (
        this.existingSubscription &&
        this.existingSubscription.id.length > 0
      ) {
        return false;
      }
      if (
        this.subscriptionType.hazardTypeId === TypeService.Flood ||
        this.subscriptionType.hazardTypeId === TypeService.Landslide
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
a {
  text-decoration: none;
  line-height: 131%;
}

.close {
  width: 66px;
}

.card-body a small {
  line-height: 44px;
}

.card-body {
  padding: 0;
  line-height: 44px;

  padding-right: 16px;
  padding-left: 16px;
}

.cancel {
  font-size: 18px;
  margin-left: 16px;
  color: #444444;
}
.info-text {
  font-family: Source Sans Pro;
  font-style: italic;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
}
</style>
